module.exports = __webpack_public_path__ + "img/febi-bilstein.7c654409.svg";